import { isUsableProfilePhotoUrl } from '../platform/chatAuthorColors';

class User {
  constructor({
    uid,
    firstName,
    lastName,
    displayName,
    email,
    role,
    photoURL,
    chatColor,
    unit,
    phone,
    jobPosition,
    workArea,
    accountStatus,
    deactivatedAt,
    deletionRequestedAt,
    scheduledDeletionAt,
  }) {
    this.uid = uid || null;
    this.firstName = firstName || "";
    this.lastName = lastName || "";
    this.displayName = displayName || `${firstName || ""} ${lastName || ""}`;
    this.email = email || "";
    this.role = role || "user";
    this.photoURL = photoURL || '';
    this.chatColor = chatColor || "";
    this.unit = unit || "";
    this.phone = phone || "";
    this.jobPosition = jobPosition || "";
    this.workArea = workArea || "";
    this.accountStatus = accountStatus ?? "ACTIVE";
    this.deactivatedAt = deactivatedAt || null;
    this.deletionRequestedAt = deletionRequestedAt || null;
    this.scheduledDeletionAt = scheduledDeletionAt || null;
  }

  toFirestore() {
    const payload = {
      uid: this.uid,
      firstName: this.firstName,
      lastName: this.lastName,
      displayName: this.displayName,
      email: this.email,
      role: this.role,
      unit: this.unit,
      phone: this.phone,
      jobPosition: this.jobPosition,
      workArea: this.workArea,
    };

    if (isUsableProfilePhotoUrl(this.photoURL)) {
      payload.photoURL = this.photoURL;
    }

    if (this.chatColor) {
      payload.chatColor = this.chatColor;
    }

    return payload;
  }

  static fromFirestore(snapshot) {
    const data = snapshot.data();
    return new User({
      uid: snapshot.id,
      firstName: data.firstName,
      lastName: data.lastName,
      displayName: data.displayName,
      email: data.email,
      role: data.role,
      photoURL: data.photoURL,
      chatColor: data.chatColor,
      unit: data.unit,
      phone: data.phone,
      jobPosition: data.jobPosition,
      workArea: data.workArea,
      accountStatus: data.accountStatus,
      deactivatedAt: data.deactivatedAt,
      deletionRequestedAt: data.deletionRequestedAt,
      scheduledDeletionAt: data.scheduledDeletionAt,
    });
  }
}

export default User;
